import { writable } from 'svelte/store';
export {interventions as interventions} from './interventions.js';
import * as d3 from 'd3';
export const dataset = writable(false);

export let capacity = (c)=>{
	return  c>4?"Sustainable":
			c>3?"Well-developed":
			c>2?"Moderate":
			c>1?"Limited":
			"Nascent";
}

export let formulas = {
	percent: (c)=>{
		return typeof c == "number" ? Math.round(c*100)+"%" : c;
	},
	boolean: (c)=>{
		return c==1? "Yes":
			c==0? "No":
			"-";
	},
	qualityLow: (c)=>{
		return c>4?"< 10%":
		c>3?"10-19%":
		c>2?"20-29%":
		c>1?"> 30%":
		c==1?"Not applicable":
		"-";
	},
	q0_2: (c)=>{
		return c==2?"Comprehensive":
		c==1?"Partial":
		"-";
	},
	q0_3: (c)=>{
		return c==3?">75%":
		c==2?"25%-75%":
		c==1?"<25%":
		"-";
	},
	t0_3: (c)=>{
		return c==3?"Completely there":
		c==2?"Partially there":
		c==1?"Not there":
		"No data";
	},
	
	s21: (c)=>{
		if(c){
			let cc = c.split("/");
			if(Number(cc[0])&&Number(cc[1])){
				return Math.round(Number(cc[0])/Number(cc[1])*100)+"% ("+cc[0]+"/"+cc[1]+")";
			}else if(cc[1]){
				return "-% (-/"+cc[1]+")";
			}
		}
		return c;
	},
	S22_JEE1: (c)=>{
		var ar = {
			1: "None",
			2: "Planned within a year",
			3: "Indicator OR event-based system in place",
			4: "In place",
			5: "In place and country uses expertise to support other countries",
		};
		return (c=='legend') ? ar : ar[c] ? ar[c] : '-';
	},
	S22_JEE2: (c)=>{
		var ar = {
			1: "None",
			2: "Being developed for either public health or veterinary surveillance systems",
			3: "In place for either public health or veterinary surveillance systems but not yet able to share data in real-time",
			4: "In place for public health and/or veterinary surveillance systems but not yet fully sustained by host government",
			5: "Fully functional for both public health and veterinary surveillance systems",
		};
		return (c=='legend') ? ar : ar[c] ? ar[c] : '-';
	},
	S22_JEE3: (c)=>{
		var ar = {
			1: "None",
			2: "Sporadic with delay",
			3: "Regular reporting with some delay; ad-hoc teams analyse data",
			4: "Annual or monthly reporting; attributed functions to experts for analysing, assessing and reporting data",
			5: "Systematic reporting; dedicated team in place for data analysis, risk assessment and reporting",
		};
		return (c=='legend') ? ar : ar[c] ? ar[c] : '-';
	},
	S22_JEE4: (c)=>{
		var ar = {
			1: "None",
			2: "Planned within a year; policy/legislation in place",
			3: "In place to detected 1-2 core syndromes",
			4: "In place to detected three or more core syndromes",
			5: "In place and country uses expertise to support other countries",
		};
		return (c=='legend') ? ar : ar[c] ? ar[c] : '-';
	},
	S22_JEE5: (c)=>{
		var ar = {
			1: "No national focal points",
			2: "Focal points appointed and linked to learning packages/best practices",
			3: "Demonstrated ability to identify potential Public Health Emergency of International Concern and file report to WHO or OIE",
			4: "Demonstrated ability to identify potential Public Health Emergency of International Concern and file report to WHO or OIE within 24 hours",
			5: "Demonstrated ability to identify potential Public Health Emergency of International Concern and file report to WHO or OIE within 24 hours and has a multisectoral process for assessing potential events",
		};
		return (c=='legend') ? ar : ar[c] ? ar[c] : '-';
	},
	S22_JEE6: (c)=>{
		var ar = {
			1: "None",
			2: "Planned within a year",
			3: "Established protocols, processes, regulations, and/or legislation governing reporting/processes for multisectoral coordination in response to potential Public Health Emergency of International Concern to WHO or OIE",
			4: "Demonstrated timely reporting of potential Public Health Emergency of International Concern to WHO or OIE in alignment with standards in selected districts",
			5: "Demonstrated timely reporting of potential Public Health Emergency of International Concern to WHO or OIE  from district to national to international level; has sustainable process for maintaining/improving reporting/communications",
		};
		return (c=='legend') ? ar : ar[c] ? ar[c] : '-';
	},
	s3b: (c)=>{
		return c==1?"Yes":"-";
	},
	s33: (c)=>{
		return c==3?"With disaggregations":
		c==2?"Missing disaggregations":
		c==1?"Not avalilable":
		c===0?"No data":
		"-";
	},
	o2_03: (c)=>{
		return c==3?"Comprehensive system":
		c==2?"Partial system":
		c==1?"No system":
		c===0?"No data":
		"Data not available";
	},
	o2_05: (c)=>{
		return c==5?"Regular and established monitoring of quality of care":
		c==4?"Ad hoc monitoring of service quality":
		c==3?"Regular monitoring of service availability and readiness only":
		c==2?"Ad hoc assessments of availability and readiness only":
		c==1?"No system":
		c===0?"No data":
		"Data not available";
	},
	o3_01: (c)=>{
		return c==1?"Yes, all based on standards":
		c==.9?"Yes, some based on standards":
		c==.8?"Yes, not based on standards":
		c===0?"No":
		"Not available";
	},
	o3_02: (c)=>{
		return c==2?"Complete tracking":
		c==1?"Partial tracking":
		c===0?"No tracking":
		"Not available";
	},

	r11_03: (c)=>{
		return c==3?"Completely":
		c==2?"Partially":
		c==1?"Limited":
		"Data not available";
	},
	
	e1: (c)=>{
		return c==3?"Completely":
		c==2?"Partially":
		c==1?"-":
		"";
	},
	e1121: (c)=>{
		return c==3?"At least quarterly":
		c==2?"Annually":
		c==1?"None or rarely":
		"";
	},

	e2111: (c)=>{
		return c==3?"> 1 time/year":
		c==2?"Annually":
		c==1?"Less than annually":
		"Data not available";
	},
	e2112: (c)=>{
		return c==3?"> Full coverage of health statistics":
		c==2?"Some coverage of health statistics":
		c==1?"Limited coverage":
		"Data not available";
	},
	e2113: (c)=>{
		return c==3?"Easy":
		c==2?"Moderately difficult":
		c==1?"Difficult":
		"Data not available";
	},

	e2121: (c)=>{
		return c==3?"Annually":
		c==2?"Every two to five years":
		c==1?"Less than every five years":
		"Data not available";
	},	
	
	
	
	e2122: (c)=>{
		return c==3?"National and sub-national disaggregations":
		c==2?"National disaggregations only":
		c==1?"Limited":
		"Data not available";
	},
	
	
	
	e213: (c)=>{
		return c==3?"Broad":
		c==2?"Restricted":
		c==1?"Not at all":
		"Data not available";
	},
	
	
	
	e214: (c)=>{
		return c==3?"Broad":
		c==2?"Restricted":
		c==1?"Not at all":
		"Data not available";
	},
	
	
	
	e215: (c)=>{
		return c==3?"Full enforcement":
		c==2?"Limited enforcement":
		c==1?"No policy":
		"Data not available";
	},


	e33: (c)=>{
		return c==4?"Enforced and actively reviewed":
		c==3?"Enforced":
		c==2?"Not enforced consistently":
		c==1?"Not enforced":
		"No";
	},


	surveyc2: (c)=>{
		return c;
	}
};

export let cleanName = (s)=>{
	if(!s)return s;
	s = s.toLowerCase();
	s = s.replace(/[ÁÀÂÃ]+/gi, "a");
	s = s.replace(/[ÉÈÊ]+/gi, "e");
	s = s.replace(/[ÍÌÎ]+/gi, "i");
	s = s.replace(/[ÓÒÔÕ]+/gi, "o");
	s = s.replace(/[ÚÙÛ]+/gi, "u");
	s = s.replace(/[Ç]+/gi, "c");
	s = s.replace(/[Ñ]+/gi, "n");
	s = s.replace("'", "_");
	s = s.replace(/[^A-Za-z\s\-\_]+/gi, "");
	s = s.replace(/\s+/gi, "_");
	s = s.replace(/-+/gi, "-");
	return s;
}

export let strip_tags = (s)=>{
	if(typeof s !== "string") return s;
	return s.replace(/(<([^>]+)>)/gi, "");
}

export let regionLabel = (n)=>{
	switch(n){
		case "afr": return "Africa"; break;
		case "amr": return "Americas"; break;
		case "sear": return "South-East Asia"; break;
		case "eur": return "Europe"; break;
		case "emr": return "Eastern Mediterranean"; break;
		case "wpr": return "Western Pacific"; break;
		default: return n;
	}
}

export let incomeLabel = (n)=>{
	switch(n){
		case "high_income": return "High income"; break;
		case "low_income": return "Low income"; break;
		case "lower_middle_income": return "Lower middle income"; break;
		case "upper_middle_income": return "Upper middle income"; break;
		default: return "";
	}
}

export let incomeLabelAdj = (n)=>{
	switch(n){
		case "high_income": return "high-income"; break;
		case "low_income": return "low-income"; break;
		case "lower_middle_income": return "lower-middle-income"; break;
		case "upper_middle_income": return "upper-middle-income"; break;
		default: return "";
	}
}

export let incomesList = ['high_income', 'upper_middle_income', 'lower_middle_income', 'low_income'];

export let capacityColor = (c)=>{
	return  c>4?"#009A8A":
			c>3?"#C3D655":
			c>2?"#FBCF1F":
			c>1?"#EA8E5A":
			c>=0?"#DC3D62":
			"#D1D1DE";
}

export let capacityTextColor = (c)=>{
	return  c>4?"#008275":
			c>3?"#a3bb4d":
			c>2?"#efba24":
			c>1?"#d27950":
			c>=0?"#b0254d":
			"#D1D1DE";
}

export let donut = (node, a) => {
	function getMeasures(element){
	  let { width, height } = element.node().getBoundingClientRect();
	  let radius = width/2;
	  let innerRadius = radius * 0.83;
	  return { width, height, radius, innerRadius };
	}

	function draw(data,id,percent,capacity,active){
		let element = d3.select(id);
		if(!element.node() || !data) return false;
		if(typeof data === "object") data = Object.values(data);
		let { width, height, radius, innerRadius } = getMeasures(element);

		element.select("*").remove();
		let svg = element.append("svg").attr("width", width).attr("height", height);

		let mainGroup = svg
		.append("g")
		.attr("transform", `translate(${width / 2}, ${height / 2})`);

		let colorScale = d3
		.scaleOrdinal()
		.range(["#DB3E64", "#EA8D5A", "#FACE36", "#C3D550", "#0C998A"])
		.domain([1,2,3,4,5]);

		let circleColorScale = d3
		.scaleOrdinal()
		.range(["#008275", "#B0254D", "#D27950", "#EFBA24", "#A3BB4D"])
		.domain([1,2,3,4,5]);

		let datasum = data.reduce((a,b)=>a+b,0);

		let pieData = d3.pie().sort(null)(data);

		let pie = mainGroup
		.selectAll("path")
		.data(pieData)
		.enter()
		.append("path")
		.attr("fill", (d,i) => {return colorScale(i+1);})
		.attr("d", d3.arc().innerRadius(innerRadius).outerRadius(radius))
		.attr("data-capacity", (d,i) => i+1);

		var cornerRadius = (radius - innerRadius) / 2;
		mainGroup
		.append("g")
		.attr("class", "corner")
		.selectAll("circle")
		.data(pieData)
		.enter()
		.datum(d=>{
	      return {
	      	angle: d.startAngle + d.padAngle / 2,
	      	radius: radius - cornerRadius,
	      	start: 0,
	      	value: d.data,
	      }
	    })
		.append("circle")
		.attr(
		  "cx",
		  (d) =>
		    d.start * cornerRadius * Math.cos(d.angle) +
		    Math.sqrt(d.radius * d.radius - cornerRadius * cornerRadius) *
		      Math.sin(d.angle)
		)
		.attr(
		  "cy",
		  (d) =>
		    d.start * cornerRadius * Math.sin(d.angle) -
		    Math.sqrt(d.radius * d.radius - cornerRadius * cornerRadius) *
		      Math.cos(d.angle)
		)
		.attr("r", cornerRadius)
		.style("stroke", "none")
		.style("fill", (d,i) => {return circleColorScale(i+1);})
		.attr("data-capacity", (d,i) => i);

		let ac = pieData[active-1];
		//console.log(ac);
		if(ac){
			drawInnerText(mainGroup,Math.round(ac.value/datasum*100)+"%",active,radius);
		}else{
			drawInnerText(mainGroup,percent,capacity,radius);
		}
	}

	function drawInnerText(mainGroup, percent="--", c=0,r=75){
	  mainGroup
	    .append("text")
	    .attr("x", 0)
	    .attr("y", (r*.1))
	    .attr("text-anchor", "middle")
	    .attr("fill", capacityColor(c))
	    .style("font-size", (r*.48)+"px")
	    .style("font-family", "Montserrat")
	    .style("font-weight", "800")
	    .text(percent);

	  mainGroup
	    .append("text")
	    .attr("x", 0)
	    .attr("y", (r*.3))
	    .attr("text-anchor", "middle")
	    .attr("fill", capacityColor(c))
	    .style("font-size", (r*.14)+"px")
	    .style("font-family", "Montserrat")
	    .style("font-weight", "800")
	    .text(capacity(c));
	}

	draw(a[0],a[1],a[2],a[3],a[4]);
	return {
		update(a) {
			draw(a[0],a[1],a[2],a[3],a[4]);
		},
	};
};

export let radar = (node, a) => {
	let getMeasures = (element) => {
	  let { width, height } = element.node().getBoundingClientRect();
	  return { width, height };
	};

	let getOptions = () => {
	  let radius = 120;
	  let levels = 3;
	  let opacityCircles = 0;
	  let labelFactorX = 70;
	  let labelFactorY = 50;
	  let wrapWidth = 120;
	  return {
	    radius,
	    levels,
	    opacityCircles,
	    labelFactorX,
	    labelFactorY,
	    wrapWidth,
	  };
	};

	let drawAxis = (data,mainGroup, axisNames, maximum, element) => {
		let {
			radius,
			levels,
			opacityCircles,
			labelFactorX,
			labelFactorY,
			wrapWidth,
		} = getOptions();

		let tooltip = element.append('div').attr("class","tooltip").node();

		let rScale;
		let maxValue;
		if(typeof maximum == "object"){
			let n = (radius/(maximum.length-1));
			let range = [];
			for (var i = 0; i < maximum.length; i++) {
				range.push(i*n);
			}
			levels = maximum.length-1;
			rScale = d3.scaleQuantile().range(range).domain(maximum);
			maxValue = maximum[maximum.length-1];
		}else{
			rScale = d3.scaleLinear().range([0, radius]).domain([0, maximum]);
			maxValue = maximum;
		}

		let angleSlice = (Math.PI * 2) / axisNames.length;
		let axisLabels = mainGroup.append("g").attr("class", "axisLabels");

		let axisl = axisLabels
		.selectAll(".axis")
		.data(axisNames)
		.enter()
		.append("g")
		.attr("class", "axis");

		axisl
		.append("text")
		.attr("class", "legend")
		.style("font-size", "9px")
		.style("font-family", "Open Sans")
		.style("font-weight", "600")
		.style("text-transform", "uppercase")
		.attr("text-anchor", "middle")
		.attr("fill", "#4F4C57")
		.attr("dy", "0.35em")
		.attr(
			"x",
			(d, i) =>
			(rScale(maxValue)+labelFactorX) * Math.cos(angleSlice * i - Math.PI / 2)
			)
		.attr(
			"y",
			(d, i) =>
			(rScale(maxValue)+labelFactorY) * Math.sin(angleSlice * i - Math.PI / 2)
			)
		.text((d) => d)
		.call(wrap, wrapWidth);
		
		let interactions = mainGroup
		.selectAll(".interactions")
		.data(data)
		.enter()
		.append("g")
		.attr("class", "interactions")
		.call(hoverTip, tooltip,(t)=>{
			let d = d3.select(t).datum();

			let leg = d.formula && formulas[d.formula] && formulas[d.formula]('legend') ? formulas[d.formula]('legend') : false;
			let o = `<header>
	                <p class="tooltip-generic-title dynamic-color">`+d.axis+`</p>
	            </header>
	            <table class="tooltip-unfolding">
	                <tbody>
	                    <tr>
	                        <td><div class="graph-legend-shape"></div><p>`+d.country_name+`</p></td>
	                        <td>`+(maximum==1?Math.round(d.country*100)+"%":(leg) ? formulas[d.formula](d.country) : d.country)+`</td>
	                    </tr>
	                    <tr>
	                        <td><div class="graph-legend-dashed"></div><p>`+d.region_name+`</p></td>
	                        <td>`+(maximum==1?Math.round(d.region*100)+"%":d.region)+`</td>
	                    </tr>
	                    <tr>
	                        <td><div class="graph-legend-solid"></div><p>`+d.income_group_name+`</p></td>
	                        <td>`+(maximum==1?Math.round(d.income_group*100)+"%":d.income_group)+`</td>
	                    </tr>
	                    <tr>
	                        <td><div class="graph-legend-solid colored"></div><p>Global</p></td>
	                        <td>`+(maximum==1?Math.round(d.global*100)+"%":d.global)+`</td>
	                    </tr>
	                </tbody>
	            </table>`;

	            if(leg){
	            	o += '<ul class="tooltip-scale">';
	            		for(var l in leg){
	            	    	o+=`<li>${l}: ${leg[l]}</li>`;
	            		}
	            	o += '</ul>';
	            }

			tooltip.setAttribute('data-size','big');
			tooltip.innerHTML = o;

		});
		
		interactions.append('line')
		.attr('stroke','rgba(0,0,0,0)')
		.attr('stroke-width',"60px")
		.attr("x2", (d, i)=>( (rScale(maxValue)+10) * Math.cos(angleSlice * i - Math.PI / 2)) )
		.attr("y2", (d, i)=>( (rScale(maxValue)+10) * Math.sin(angleSlice * i - Math.PI / 2)) )

		interactions.append('circle')
		.attr('fill','rgba(0,0,0,0)')
		.attr('r',"75px")
		.attr("cx", (d, i)=>( (rScale(maxValue)+labelFactorX) * Math.cos(angleSlice * i - Math.PI / 2)) )
		.attr("cy", (d, i)=>( (rScale(maxValue)+labelFactorY) * Math.sin(angleSlice * i - Math.PI / 2)) )

		
		
		let axisGrid = mainGroup.append("g").attr("class", "axisWrapper");
		
		axisGrid
		.selectAll(".levels")
		.data(d3.range(1, levels + 1).reverse())
		.enter()
		.append("circle")
		.attr("class", "gridCircle")
		.attr("r", (d, i) => (radius / levels) * d)
		.attr("stroke", "#EFEFEF")
		.attr("stroke-width", "2px")
		.attr("fill-opacity", opacityCircles);

		let axis = axisGrid
		.selectAll(".axis")
		.data(axisNames)
		.enter()
		.append("g")
		.attr("class", "axis");

		axis
		.append("line")
		.attr("x1", 0)
		.attr("y1", 0)
		.attr("x2", (d, i)=>( (rScale(maxValue)+10) * Math.cos(angleSlice * i - Math.PI / 2)) )
		.attr("y2", (d, i)=>( (rScale(maxValue)+10) * Math.sin(angleSlice * i - Math.PI / 2)) )
		.attr("class", "line")
		.style("stroke", "#EFEFEF")
		.style("stroke-width", "2px");

		let radarLine = d3
		.lineRadial()
		.curve(d3.curveLinearClosed)
		.radius(function (d) {
			return rScale(d.value);
		})
		.angle(function (d, i) {
			return i * angleSlice;
		});

		let redArea = mainGroup
		.append("path")
		.attr("class", "radar_country")
		.attr("d", radarLine(data.map(a=>{ a.value = Number(a.country) ? a.country : 0; return a; })));

		let blackDashedLine = mainGroup
		.append("path")
		.attr("class", "radar_region")
		.attr("d", radarLine(data.map(a=>{ a.value = Number(a.region) ? a.region : 0; return a; })));

		let blackLine = mainGroup
		.append("path")
		.attr("class", "radar_income_group")
		.attr("d", radarLine(data.map(a=>{ a.value = Number(a.income_group) ? a.income_group : 0; return a; })));

		let redLine = mainGroup
		.append("path")
		.attr("class", "radar_global")
		.attr("d", radarLine(data.map(a=>{ a.value = Number(a.global) ? a.global : 0; return a; })));

	};

	let wrap = (text, width) => {
	  text.each(function () {
	    var text = d3.select(this),
	      words = text.text().split(/\s+/).reverse(),
	      word,
	      line = [],
	      lineNumber = 0,
	      lineHeight = 1.4, // ems
	      y = text.attr("y"),
	      x = text.attr("x"),
	      dy = parseFloat(text.attr("dy")),
	      tspan = text
	        .text(null)
	        .append("tspan")
	        .attr("x", x)
	        .attr("y", y)
	        .attr("dy", dy + "em");

	    while ((word = words.pop())) {
	      line.push(word);
	      tspan.text(line.join(" "));
	      if (tspan.node().getComputedTextLength() > width) {
	        line.pop();
	        tspan.text(line.join(" "));
	        line = [word];
	        tspan = text
	          .append("tspan")
	          .attr("x", x)
	          .attr("y", y)
	          .attr("dy", ++lineNumber * lineHeight + dy + "em")
	          .text(word);
	      }
	    }
	  });
	};

	let hoverTip = (t,tooltip,fn) => {
		if(tooltip){
			t.on("mouseover",function(e){
				if(fn) fn(this);
				positionTooltip(tooltip,e);
				tooltip.classList.add("active");
				this.parentNode.classList.add("interactionActive");
				this.classList.add("active");
			}).on("mousemove",function(e){
				positionTooltip(tooltip,e);
			}).on("mouseout",function(e){
				closeTips(tooltip);
				this.parentNode.classList.remove("interactionActive");
				this.classList.remove("active");
			});
		}
	};

	let draw = (data,id,maxDef) => {
		let element = d3.select(id);
		if(!element.node() || !data) return false;
		if(typeof data === "object") data = Object.values(data);

		let { width, height, radius, levels, opacityCircles } = getMeasures(element);

		element.selectAll("svg").remove();
		let svg = element.append("svg").attr("width", width).attr("height", height);

		let mainGroup = svg
		.append("g")
		.attr("transform", `translate(${width / 2}, ${height / 2})`);

		var axisNames = data.map((d) => d.axis);

		if(maxDef){
			var maxValue = maxDef;
		}else{
			var maxValue = d3.max(data, function (d) {
				return d3.max([d.country, d.region, d.income_group, d.global]);
			});
		}
		if(data[0] && data[0].global){
			drawAxis(data, mainGroup, axisNames, maxValue, element);
		}
	};

	return {
		update(a) {
			draw(a[0],a[1],a[2]);
		},
	};
};

export let progression = (node, a) => {
	let getMeasures = (element) => {
	  let { width, height } = element.node().getBoundingClientRect();
	  let radius = 120;
	  let innerRadius = 120 * 0.8;
	  return { width, height, radius, innerRadius };
	};
	let calcPercent = (percent) => {return [percent, 1 - percent];};
	let isOdd = (num) => {return num % 2;};

	let wrap = (text, width) => {
	  text.each(function () {
	    var text = d3.select(this),
	      words = text.text().split(/\s+/).reverse(),
	      word,
	      line = [],
	      lineNumber = 0,
	      lineHeight = 1.4, // ems
	      y = text.attr("y"),
	      x = text.attr("x"),
	      dy = parseFloat(text.attr("dy")),
	      tspan = text
	        .text(null)
	        .append("tspan")
	        .attr("x", x)
	        .attr("y", y)
	        .attr("dy", dy + "em");

	    while ((word = words.pop())) {
	      line.push(word);
	      tspan.text(line.join(" "));
	      if (tspan.node().getComputedTextLength() > width) {
	        line.pop();
	        tspan.text(line.join(" "));
	        line = [word];
	        tspan = text
	          .append("tspan")
	          .attr("x", x)
	          .attr("y", y)
	          .attr("dy", ++lineNumber * lineHeight + dy + "em")
	          .text(word);
	      }
	    }
	  });
	};

	let dashedPieData = [];
	let totalDashes = 125;
	for (let index = 0; index < totalDashes; index++) {
		dashedPieData.push(0.8);
	}

	let draw = (data,id) => {
		let element = d3.select(id);
		if(!element.node() || !data) return false;

		let { width, height, radius, innerRadius } = getMeasures(element);

		element.selectAll("svg").remove();
		let svg = element.selectAll("svg").data(data).enter().append("svg").attr("width", height).attr("height", height);

		let mainGroup = svg
		.append("g")
		.attr("transform", `translate(${height / 2}, ${height / 2})`);

		let arc = d3.arc().innerRadius(innerRadius).outerRadius(radius);

		let progression_country = mainGroup
		.selectAll("path")
		.data(d=>d3.pie().sort(null)(calcPercent(d.country)))
		.enter()
		.append("path")
		.classed("progression_country", true)
		.style("opacity", (d, i) => (i == 0 ? "0.5" : "0"))
		.attr("d", d3.arc().innerRadius(innerRadius).outerRadius(radius));

		let progression_region = mainGroup
		.selectAll(".regionPercent")
		.data(d=>d3.pie()(dashedPieData).map(m=>{m.region = d.region; return m;}))
		.enter()
		.append("path")
		.classed("progression_region", true)
		.style("opacity", (d, i) =>{ return(isOdd(i) && i < Math.round(totalDashes * d.region) ? 1 : 0)})
		.attr(
			"d",
			d3
			.arc()
			.innerRadius(innerRadius - 1)
			.outerRadius(innerRadius + 1)
			);

		let progression_income_group = mainGroup
		.selectAll(".incomePercent")
		.data(d=>d3.pie().sort(null)(calcPercent(d.income_group)))
		.enter()
		.append("path")
		.classed("progression_income_group", true)
		.style("opacity", (d, i) => (i == 0 ? "1" : "0"))
		.attr(
			"d",
			d3
			.arc()
			.innerRadius(radius - 2)
			.outerRadius(radius)
			);

		let progression_global = mainGroup
		.selectAll(".globalPercent")
		.data(d=>d3.pie().sort(null)(calcPercent(d.global)))
		.enter()
		.append("path")
		.classed("progression_global", true)
		.style("opacity", (d, i) => (i == 0 ? "1" : "0"))
		.attr(
			"d",
			d3
			.arc()
			.innerRadius(radius - (radius - innerRadius) / 2 - 2)
			.outerRadius(radius - (radius - innerRadius) / 2)
			);

		mainGroup
			.append("text")
			.attr("x", 0)
			.attr("y", -5)
			.attr("text-anchor", "middle")
			.attr("fill", "#2386C8")
			.classed("progression_label",1)
			.style("font-size", "24px")
			.style("font-family", "Montserrat")
			.style("font-weight", "800")
			.text(d=>d.country?d3.format(".0%")(d.country):'-');

		let tt = mainGroup
			.append("text")
			.attr("x", 0)
			.attr("y", 5)
			.attr("text-anchor", "middle")
			.attr("fill", "#4F4C57")
			.style("font-size", "12px")
			.style("font-family", "Open Sans")
			.style("font-weight", "400")
			.attr("dy", "0.5em")
			.text(d=>d.label)
			.call(wrap, innerRadius);
	};
	
	draw(a[0],a[1]);
	return {
		update(a) {
			draw(a[0],a[1]);
		},
	};
};

export let positionTooltip = (tooltip,e)=>{ 
	if(tooltip){
		let ww = window.innerWidth;
		let wh = window.innerHeight;
		let ml = tooltip.offsetWidth/2;
		let mt = tooltip.offsetHeight/2;
		let x = e.clientX;
		let y = e.clientY;
		let top = y-tooltip.offsetHeight-25;
		let left = Math.max((ml+30),Math.min(ww-(ml+30),x));
		tooltip.dataset.position = "bottom";

		if(x < ml+30){
				left = x+ml+25;
				top = Math.max((y-mt),Math.min(60));
				tooltip.dataset.position = "left";
		}
		else if(x > ww-(ml+30)){
				left = x-ml-25;
				top = Math.max((y-mt),Math.min(60));
				tooltip.dataset.position = "right";
		}
		else if(top < 10){
				top = y+25;
				tooltip.dataset.position = "top";
		}
		tooltip.style.left=left+"px";
		tooltip.style.top=top+"px";
		tooltip.style.marginLeft=-ml+"px";
	}
}

export let closeTips = (tooltip,tooltipCompare)=>{
	if(tooltip) tooltip.classList.remove("active");
	if(tooltipCompare) tooltipCompare.classList.remove("active");
}